/* ==========================================================================
   Koji Product Section - Custom JS
   ========================================================================== */

/* --- Media Gallery --- */
if (!customElements.get('koji-media-gallery')) {
  customElements.define(
    'koji-media-gallery',
    class KojiMediaGallery extends HTMLElement {
      constructor() {
        super();
        this.thumbnails = this.querySelectorAll('.koji-product__thumbnail');
        this.mainImages = this.querySelectorAll('.koji-product__main-image');
        this.swiperTrack = this.querySelector('.koji-product__swiper-track');
        this.dots = this.querySelectorAll('.koji-product__dot');
        this.currentIndex = 0;
        this.touchStartX = 0;
        this.touchEndX = 0;
      }

      connectedCallback() {
        this.bindThumbnails();
        this.bindDots();
        this.bindSwipe();
        this.bindVariantChange();
      }

      bindThumbnails() {
        this.thumbnails.forEach((thumb, index) => {
          thumb.addEventListener('click', () => this.goToSlide(index));
        });
      }

      bindDots() {
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goToSlide(index));
        });
      }

      bindSwipe() {
        const swiper = this.querySelector('.koji-product__swiper');
        if (!swiper) return;

        swiper.addEventListener('touchstart', (e) => {
          this.touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        swiper.addEventListener('touchend', (e) => {
          this.touchEndX = e.changedTouches[0].screenX;
          this.handleSwipe();
        }, { passive: true });
      }

      handleSwipe() {
        const diff = this.touchStartX - this.touchEndX;
        const threshold = 50;
        const slideCount = this.dots.length || this.thumbnails.length;

        if (Math.abs(diff) < threshold) return;

        if (diff > 0 && this.currentIndex < slideCount - 1) {
          this.goToSlide(this.currentIndex + 1);
        } else if (diff < 0 && this.currentIndex > 0) {
          this.goToSlide(this.currentIndex - 1);
        }
      }

      goToSlide(index) {
        this.currentIndex = index;

        // Update thumbnails
        this.thumbnails.forEach((t, i) => t.classList.toggle('is-active', i === index));

        // Update main images (desktop)
        this.mainImages.forEach((img, i) => {
          img.style.display = i === index ? 'block' : 'none';
        });

        // Update swiper (mobile/tablet)
        if (this.swiperTrack) {
          this.swiperTrack.style.transform = `translateX(-${index * 100}%)`;
        }

        // Update dots
        this.dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      }

      bindVariantChange() {
        if (typeof subscribe === 'undefined') return;

        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const productInfo = this.closest('product-info');
          if (!productInfo || productInfo.dataset.section !== data.sectionId) return;

          const variant = data.variant;
          if (!variant?.featured_media?.id) return;

          // Find the index of the featured media
          const mediaId = `${data.sectionId}-${variant.featured_media.id}`;
          const thumbIndex = Array.from(this.thumbnails).findIndex(
            (t) => t.dataset.mediaId === mediaId
          );

          if (thumbIndex >= 0) {
            this.goToSlide(thumbIndex);
          }
        });
      }

      // Called by product-info.js updateMedia
      setActiveMedia(mediaId) {
        const thumbIndex = Array.from(this.thumbnails).findIndex(
          (t) => t.dataset.mediaId === mediaId
        );
        if (thumbIndex >= 0) {
          this.goToSlide(thumbIndex);
        }
      }
    }
  );
}

/* --- Sticky Mobile ATC --- */
if (!customElements.get('koji-sticky-atc')) {
  customElements.define(
    'koji-sticky-atc',
    class KojiStickyAtc extends HTMLElement {
      constructor() {
        super();
        this.observer = null;
      }

      connectedCallback() {
        const targetSelector = this.dataset.observeTarget;
        const target = document.querySelector(targetSelector);
        if (!target) return;

        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.classList.toggle('is-visible', !entry.isIntersecting);
          },
          { threshold: 0, rootMargin: '0px' }
        );

        this.observer.observe(target);

        // Bind the sticky ATC button to submit the main product form
        const btn = this.querySelector('.koji-sticky-atc__btn');
        if (btn) {
          btn.addEventListener('click', () => {
            const form = document.querySelector('product-form form');
            if (form) {
              form.requestSubmit();
            }
          });
        }

        // Listen for variant changes to update price
        if (typeof subscribe !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            const productInfo = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
            if (!productInfo || !this.closest('product-info')?.contains(productInfo) && this.dataset.section !== data.sectionId) return;

            const variant = data.variant;
            if (!variant) return;

            const priceEl = this.querySelector('.koji-sticky-atc__price');
            if (priceEl && variant.price) {
              const formatted = Shopify.formatMoney(variant.price);
              priceEl.textContent = formatted;
            }
          });
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}

/* --- Accordion Toggle --- */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.koji-product__accordion-trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const accordion = trigger.closest('.koji-product__accordion');
      if (!accordion) return;
      accordion.classList.toggle('is-open');
    });
  });
});

/* --- Purchase Option Cards --- */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.koji-product__purchase-card').forEach((card) => {
    card.addEventListener('click', () => {
      const group = card.closest('.koji-product__purchase-cards');
      if (!group) return;

      group.querySelectorAll('.koji-product__purchase-card').forEach((c) => c.classList.remove('is-selected'));
      card.classList.add('is-selected');

      const radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
    });
  });
});
